import { createAsyncThunk } from '@reduxjs/toolkit';
import { sendClientPortalChatAttachment } from 'services/pod';
import { IClientPortalChatMessage } from 'services/pod/types';

interface IPayload {
  chatId: string | number;
  file: FormData;
  fileType: string;
}

export const ThunkSendClientPortalChatAttachment = createAsyncThunk<IClientPortalChatMessage, IPayload>(
  'clientPortalChats/sendClientPortalChatAttachment',
  async payload => {
    const r = await sendClientPortalChatAttachment(
      payload.chatId,
      payload.file,
      payload.fileType
    );
    return { ...r.data };
  },
);
